import { Permission } from 'api';
import { RouteDefinition } from './types';

export const getUsersRoutes = (basePath: string) => ({
  to: basePath,
  path: basePath,
  requiresAny: [Permission.ViewUsers, Permission.ManageUsers],
  list: {
    to: basePath,
    path: basePath,
    requiresAny: [Permission.ViewUsers, Permission.ManageUsers],
  } as RouteDefinition,
  add: {
    to: `${basePath}/add`,
    path: 'add',
    requiresAll: [Permission.ManageUsers],
  } as RouteDefinition,
  details: {
    to: `${basePath}/:userId`,
    path: ':userId',
    requiresAny: [Permission.ViewUsers, Permission.ManageUsers],
  } as RouteDefinition,
});
